// Main entry point - Converted from Nuxt app.vue
// Initializes React application with routing and global providers
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { StoreProvider } from './contexts/StoreContext';

// Import global CSS files (converted from nuxt.config.ts)
import './assets/css/bootstrap.min.css';
import './assets/css/bootstrap-datepicker.min.css';
import './assets/css/animate.min.css';
import './assets/plugins/glightbox/glightbox.min.css';
import './assets/css/fontawesome-all.min.css';
import './assets/css/agrikol_iconl.css';
import './assets/css/style.css';
import './assets/css/responsive.css';
import './assets/css/custom.css';
import 'tiny-slider/dist/tiny-slider.css';

// Initialize WOW.js for animations (converted from app.vue)
if (typeof window !== 'undefined') {
  import('wow.js').then(({ default: WOW }) => {
    const wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true,
    });
    wow.init();
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <StoreProvider>
        <App />
      </StoreProvider>
    </BrowserRouter>
  </React.StrictMode>
);
